const encrypt = {
  data() {
    return {
      alphabet: [
        'A', 'B', 'C', 'D', 'E', 'F',
        'G', 'H', 'I', 'J', 'K', 'L',
        'M', 'N', 'O', 'P', 'Q', 'R',
        'S', 'T', 'U', 'V', 'W', 'X',
        'Y', 'Z',
        'a', 'b', 'c', 'd', 'e', 'f',
        'g', 'h', 'i', 'j', 'k', 'l',
        'm', 'n', 'o', 'p', 'q', 'r',
        's', 't', 'u', 'v', 'w', 'x',
        'y', 'z',
        '1', '2', '3', '4', '5',
        '6', '7', '8', '9', '0',
        '.', ',', ':', '-', '{', '}', '/', '"'
      ],
      shift: 12,
    }
  },
  methods: {
    encrypt(data) {
      return [...data].map(char =>
        this.setChar(char, this.shift)).join('')
    },
    decrypt(data) {
      // console.log(encrypt.data())
      let alphabetLen = ''
      let shift = ''
      if (!this.alphabet) { // karena this tidak bisa dipakai diluar component. misal mixin dipanggil di store
        const data = encrypt.data()
        alphabetLen = data.alphabet.length
        shift = data.shift
      } else {
        alphabetLen = this.alphabet.length
        shift = this.shift
      }
      let reverse_shift = (alphabetLen - shift) % alphabetLen
      return [...data].map(char =>
        this.setChar(char, reverse_shift)).join('')
    },
    setChar(char, shift) {
      let alphabet = ''
      if (!this.alphabet) {
        const data = encrypt.data()
        alphabet = data.alphabet
      } else {
        alphabet = this.alphabet
      }
      let include = alphabet.includes(char)

      if (include) {
        let position = alphabet.indexOf(char)
        let new_position = (position + shift) % alphabet.length
        return alphabet[new_position]
      } else {
        return char
      }
    },
    encryptWithShift(data, shift) {
      return [...data].map(char =>
        this.setChar(char, shift)).join('')
    }
  }
}

export default encrypt